import { SyncableSingle } from "shared/state/models/syncable";
import {  IDistriwinOption } from "shared/api/api";


export const SYNC_DATA_DISTRIWIN_OPTION = 'SYNC_DATA_DISTRIWIN_OPTION';

export interface DistriwinOptionState extends SyncableSingle<IDistriwinOption>  {
}

